/* UK draft only. Kiwi retains ownership of its charts, matching and modal. */
(() => {
  function init() {
    document.querySelectorAll('modal-dialog[data-size-chart-switch-url]').forEach((modal) => {
      if (modal.sizeChartRouterInit) return;
      const opener = Array.from(document.querySelectorAll('modal-opener')).find((item) => item.dataset.modal === modal.id);
      const button = opener && opener.querySelector('button');
      if (!button) return;
      modal.sizeChartRouterInit = true;
      const section = opener.closest('.shopify-section') || opener.closest('section');
      if (!section) return;
      section.classList.add('size-chart-routed');
      let sequence = 0;
      let controller;
      let busy = false;
      const setBusy = (value) => {
        busy = value;
        button.setAttribute('aria-busy', String(value));
      };
      const current = (id, fromNew) => id === sequence && (!fromNew || modal.hasAttribute('open'));
      function unavailable() {
        modal.dataset.sizeChartFallbackError = 'true';
        modal.open(button);
        const status = modal.querySelector('[data-size-chart-status]');
        const root = modal.querySelector('[data-size-chart-root]');
        if (root) root.replaceChildren();
        if (status) {
          const message = document.createElement('p');
          message.textContent = 'Size chart is temporarily unavailable.';
          const contact = document.createElement('a');
          contact.href = modal.dataset.sizeChartContactUrl || '/pages/contact';
          contact.textContent = 'Contact us';
          status.hidden = false;
          status.replaceChildren(message, contact);
        }
      }
      function legacy(id, fromNew = false) {
        return new Promise((resolve) => {
          let observer;
          const finish = (link) => {
            window.clearTimeout(timer);
            if (observer) observer.disconnect();
            if (current(id, fromNew)) {
              if (link) {
                if (modal.hasAttribute('open')) modal.close();
                link.click();
              } else unavailable();
            }
            resolve();
          };
          const find = () => section.querySelector('.ks-chart-modal-link');
          const timer = window.setTimeout(() => finish(null), 8000);
          const link = find();
          if (link) return finish(link);
          observer = new MutationObserver(() => {
            if (!current(id, fromNew)) return finish(null);
            const ready = find();
            if (ready) finish(ready);
          });
          observer.observe(section, { childList: true, subtree: true });
        });
      }
      opener.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy) return;
        const id = ++sequence;
        setBusy(true);
        delete modal.dataset.sizeChartFallbackError;
        if (controller) controller.abort();
        controller = new AbortController();
        const timer = window.setTimeout(() => controller.abort(), 3000);
        let enabled = false;
        try {
          const response = await fetch(modal.dataset.sizeChartSwitchUrl, { cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
          if (response.ok) enabled = (await response.json()).enabled === true;
        } catch (_) { /* Unreachable switch service also returns control to Kiwi. */ }
        window.clearTimeout(timer);
        if (id !== sequence) return;
        if (enabled && modal.sizeChartInit) modal.open(button);
        else await legacy(id);
        if (id === sequence) setBusy(false);
      }, true);
      modal.addEventListener('size-chart:failed', async () => {
        if (!modal.hasAttribute('open')) return;
        const id = ++sequence;
        setBusy(true);
        await legacy(id, true);
        if (id === sequence) setBusy(false);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
